import {GeoJsonLayer} from '@deck.gl/layers';
import * as turf from '@turf/turf'

export const chat_notifications_layer = (id, coords, notifications_count) => {
  return(
    new GeoJsonLayer({
      id: id,
      data: turf.point(coords, {id: id}),
      pickable: true,
      pointType: "text",
      getText: o => `${notifications_count}`,
      getTextColor: o => [255, 255, 255, 255],
      getTextAngle: o => 0,
      getTextSize: o => 12,
      getTextAnchor: o => 'end',
      getTextPixelOffset: o => [21, -15],
      getTextAlignmentBaseline: o => 'center',
      textSizeUnits: 'pixels',
      textSizeScale: 1,
      textCharacterSet: [" ", "0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
      textFontFamily: 'monospace',
      textFontWeight: 'bold',
      textMaxWidth: -1,
      textWordBreak: 'break-word',
      textBackground: true, // need for BackgroundColor
      textBackgroundPadding: [
        3, 1, 3, 1 // left, top, right, bottom
      ],
      getTextBackgroundColor: o => [255, 0, 0, 255],
      getTextBorderColor: o => [0, 0, 0, 255],
      getTextBorderWidth: o => 1,
      textOutlineColor: [0, 0, 0, 0],
      textOutlineWidth: 0,
      textFontSettings: {sdf: true} // need for Outline
    })
  )
}
